import { DataColumns } from '../DataColumns/DataColumns';
import GridFlag from '../../../../Core/Components/GridFlag/GridFlag';
import {
  TenantFilterCell,
  GridDateCell,
  BooleanFlagFilterCell,
} from '../../../../Core/Components/Filter/FilterElements';
import { MultiViewCalenderFilterCell } from 'smart-react';

/**
 * Generates a list of columns for a grid.
 * @param {object} options - The options for the grid.
 * @returns {Array} - The list of grid columns.
 */
export const GridColumnsList = async ({
  editScreen,
  dateRangefilter,
  setDateRangeFilter,
  isActive,
}) => {
  return DataColumns({
    editScreen,
    TenantFilterCell,
    MultiViewCalenderFilterCell,
    dateRangeFilter: dateRangefilter,
    setDateRangeFilter,
    GridDateCell,
    GridFlag,
    BooleanFlagFilterCell,
    isActive,
  });
};

export default GridColumnsList;
